import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React, { FunctionComponent } from "react";
import Avatar from "@material-ui/core/Avatar";

const useStyle = makeThemedStyles("AvatarCard", (theme) => ({
  text: {
    display: "flex",
    flexDirection: "column",
  },
  root: {
    display: "flex",
    gap: "10px",
  },
  name: {
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: "1.5em",
  },
  subtitle: {
    color: "rgba(107, 114, 128, 1)",
    fontSize: "13px",
  },
}));
export interface AvatarCardProps {
  imgUrl?: string;
  name: string;
  subtitle: string;
}

export const AvatarCard: FunctionComponent<AvatarCardProps> = (props) => {
  const styles = useStyle();
  return (
    <div className={styles.root}>
      <Avatar alt={props.name} src={props.imgUrl} />
      <div className={styles.text}>
        <div className={styles.name}>{props.name}</div>
        <div className={styles.subtitle}>{props.subtitle}</div>
      </div>
    </div>
  );
};
